import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';

export const VisualsRedirect = () => {
  const navigate = useNavigate();

  useEffect(() => {
    // Навигация на главную
    navigate('/', { replace: true });

    // Скроллим к нужной секции после короткой задержки
    setTimeout(() => {
      const element = document.getElementById('visuals');
      if (element) {
        element.scrollIntoView({ behavior: 'smooth' });
      }
    }, 300);
  }, [navigate]);

  return null;
}
